import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Comparison = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill={fill}
      stroke="none"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M12.8 0a12.8 12.8 0 1 0 12.8 12.8A12.838 12.838 0 0 0 12.8 0zM1.6 12.8A11.123 11.123 0 0 1 12 1.68V24A11.253 11.253 0 0 1 1.6 12.8z"
        transform="translate(3 3)"
      />
    </svg>
  );
};

Comparison.displayName = 'Comparison';
